namespace Matrix.Dashboards {
    export class WidgetCatalogColumns {
        static columnsKey = 'Dashboards.WidgetCatalog';
    }
}
